export default "<p>control-timepicker works!</p>\r\n"